import { Component, Input } from '@angular/core';

@Component({
    selector: 'collapsible-container',
    templateUrl: './collapsible-container.component.html',
    styleUrls: ['./collapsible-container.component.scss']
})
export class CollapsibleContainerComponent {

    @Input("collapsed")
    collapsed: boolean = true;

    toggle():void {
        this.collapsed = !this.collapsed;
    }

}
